import { type FC } from 'react';

import { type AdditionalContentField } from '@core/blocks/edu-flow-2/components/AdditionalContentFields/types';

import ChartPanel from '../components/AdditionalContentFields/ChartPanel';
import InfoPanelDesktop from '../components/AdditionalContentFields/InfoPanel/Desktop';
import StatCta from '../components/AdditionalContentFields/StatCta';

const additionalContentFieldTypeDictionary = {
  infoPanel: InfoPanelDesktop,
  statCta: StatCta,
  chart: ChartPanel,
};
export type AdditionalContentFieldType = keyof typeof additionalContentFieldTypeDictionary;
export type AdditionalFieldComponentProps<T extends AdditionalContentField = AdditionalContentField> = {
  field: T;
};

export type AdditionalContentFieldComponent = FC<AdditionalFieldComponentProps>;
export default additionalContentFieldTypeDictionary as Record<
  AdditionalContentFieldType,
  AdditionalContentFieldComponent
>;
